import { render, staticRenderFns } from "./FormQuestionCheckboxType.vue?vue&type=template&id=afef9eb0"
import script from "./FormQuestionCheckboxType.vue?vue&type=script&lang=js"
export * from "./FormQuestionCheckboxType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('afef9eb0')) {
      api.createRecord('afef9eb0', component.options)
    } else {
      api.reload('afef9eb0', component.options)
    }
    module.hot.accept("./FormQuestionCheckboxType.vue?vue&type=template&id=afef9eb0", function () {
      api.rerender('afef9eb0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/pages/form/FormApp/FormQuestionCheckboxType.vue"
export default component.exports